import styled from "styled-components";
import { BlockStyled } from "../../../styles/shared-styles";
import { Button, Heading, Text, Input } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const LoginPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs}%;
  padding-top: 5rem;
`;

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.xxsmall};
  margin-top: 0;
  text-transform: capitalize;
  font-weight: ${props => props.theme.font.weight.regular};
  line-height: 3rem;
`;

export const ContainerStyled = styled.div`
  display: flex;
  ${props => props.userLogged && `justify-content: space-around;`}
  justify-content: space-between;
  height: 100%;
  margin-top: 6.421rem;
`;

export const BlockLoginStyled = styled(BlockStyled)`
  width: 34vw;
`;

export const ImageAndInputBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const InputContainerStyled = styled.div`
  width: 27rem;
  margin-top: ${props => props.theme.spacing.xxsmall};
`;
export const InputStyled = styled(Input)`
  height: 4rem;
`;

export const ButtonsGroupStyled = styled.div`
  display: flex;
  margin: ${props => props.theme.spacing.xsmall} 0;
  margin-top: 2.5rem;
`;

export const KeyButtonStyledBack = styled(Button)`
  flex: 1;
  height: 3.4rem;
  background: ${props => props.theme.color.secondary};
  border-radius: 0.4rem;
  font-weight: 600;
  font-size: 1.5rem;
  padding: 0;
  -webkit-transition: transform ease 0.1s;
  transition: transform ease 0.1s;
  span {
    line-height: 1;
    vertical-align: unset;
  }

  &.focused {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const KeyButtonStyledNext = styled(KeyButtonStyledBack)`
  flex: 1;
  ${props => `${props.direction === "ltr" ? "margin-left" : "margin-right"}: ${props.theme.spacing.xsmall}`};
  opacity: 1;
   -webkit-transition: opacity linear 0.2s;
  transition: opacity linear 0.2s;
  ${props => props.disabled && `opacity: 0.6`};
  }
`;

export const TextStyled = styled(Text)`
  color: ${props => props.theme.color.greyLight};
  font-size: ${props => props.theme.font.size.small};
`;

export const ProfileImageContainer = styled.div`
  height: 15rem;
  width: 15rem;
  border-radius: 50%;
`;

export const ProfileImage = styled.img`
  height: 100%;
  width: 100%;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.24);
  border-radius: 50%;
`;

export const LogoStyled = styled.div`
  position: absolute;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}:4.6rem`};
`;
